import styled from 'styled-components';
import type { ReactNode } from 'react';
import { media } from 'helpers/breakpoints';

export type WhitePanelProps = {
  children: ReactNode;
  className?: string;
  testId?: string;
};

const Container = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.default};
  background: ${({ theme }) => theme.colors.WHITE};
  box-shadow: ${({ theme }) => theme.shadow.CONTAINER};
  padding: ${({ theme }) => theme.spacing.M16};

  ${media.large} {
    padding: ${({ theme }) => theme.spacing.M24};
  }
`;

function WhitePanel({ children, className, testId, ...rest }: WhitePanelProps) {
  return (
    <Container className={className} data-testid={testId} {...rest}>
      {children}
    </Container>
  );
}

export { WhitePanel };
